import { captureException } from '@sentry/browser'

export const logger = props => {
  if (props && props.error && props.info) {
    captureException({ ...props.error, ...props.info })
  }
}
